import { type UserSettings } from "services/suno-comms/types/user-settings.type";
import { type VoiceUserSettingsValues } from "./voice-user-settings-tab.component";
import { omit } from "lodash";

export const DEFAULT_VOICE_USER_VALUES: VoiceUserSettingsValues = {
  ring_web_app: true,
  ring_mobile_app: false,
  do_not_disturb: false,
  block_unknown_number: false,
  notify_email: false,
  call_forwarding: false,
  forward_to: "",
  default_microphone: "default",
  default_speaker: "default",
  default_volume: "100",
};

export const formatVoiceUserSettings = (data: UserSettings | undefined) => {
  if (!data?.id) return data;

  const result: VoiceUserSettingsValues = {
    ring_web_app: Boolean(data.ring_web_app),
    ring_mobile_app: Boolean(data.ring_mobile_app),
    do_not_disturb: Boolean(data.do_not_disturb),
    block_unknown_number: Boolean(data.block_unknown_number),
    notify_email: Boolean(data.notify_email),
    call_forwarding: Boolean(data.call_forwarding),
    forward_to: String(data.forward_to || ""),
    default_microphone: data.default_microphone || "default",
    default_speaker: data.default_speaker || "default",
    default_volume: isNaN(parseInt(String(data?.default_volume)))
      ? "100"
      : String(Number(data?.default_volume)),
  };

  return result;
};

export const formatVoiceUserSettingsInput = (
  data: Partial<VoiceUserSettingsValues>
) => {
  return {
    ...omit(
      data,
      "location",
      "user",
      "discarded_at",
      "created_at",
      "updated_at"
    ),
    location_id: data.location?.id,
    ring_web_app: Boolean(data.ring_web_app),
    ring_mobile_app: Boolean(data.ring_mobile_app),
    do_not_disturb: Boolean(data.do_not_disturb),
    block_unknown_number: Boolean(data.block_unknown_number),
    notify_email: Boolean(data.notify_email),
    call_forwarding: Boolean(data.call_forwarding),
    forward_to: String(data.forward_to || ""),
    default_microphone: data.default_microphone || "default",
    default_speaker: data.default_speaker || "default",
    default_volume: String(Number(data.default_volume || 0)),
  };
};
